export default __webpack_public_path__ + "static/media/KZ.T.15.2500 black.af8888e6.svg";